import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const useOutfitCollageFlyoutOpenedState = (uniqueKey: string) => {
  const {cancel, isOpen, open} = useOpenedStateManager(uniqueKey);

  return {
    cancel,
    isOpen,
    openFlyout: open,
  };
};
